export default "__VITE_ASSET__BQsBd$h6__"